export const videoPlaybackState = {
    defaultState: {
        videoVolume: 1,
        videoMuted: false,
        landingVideoFocused: false,
    },
    actions: {
        setVideoVolume: (volume, state) => ({...state, videoVolume: Math.min(Math.max(volume, 0), 1)}),
        setVideoMuted: (muted, state) => ({...state, videoMuted: muted}),
        setLandingVideoFocused: (focused, state) => ({...state, landingVideoFocused: focused}),
    },
}
